/**
 * The order of these properties is important
 */
export class TramsPolicyDescription {
    public policyNumber: string = null;
    public packageName: string = null;
    public expirationDate: string = null;
    public localExpirationDate: string = null;
    public expirationTimezone: string = null;
    public effectiveDate: string = null;
    public localEffectiveDate: string = null;
    public effectiveTimezone: string = null;
    public tripDepositDate: string = null;
    public localDepartureDate: string = null;
    public departureDate: string = null;
    public localReturnDate: string = null;
    public returnDate: string = null;
    public destinationCity: string = null;
    public destinationState: string = null;
    public destinationCountry: string = null;
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/typescript/shared/models/trams-policy-description.model.ts